import { render, staticRenderFns } from "./DustAnimation.vue?vue&type=template&id=3454a384&scoped=true"
import script from "./DustAnimation.vue?vue&type=script&lang=js"
export * from "./DustAnimation.vue?vue&type=script&lang=js"
import style0 from "./DustAnimation.vue?vue&type=style&index=0&id=3454a384&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3454a384",
  null
  
)

export default component.exports